/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { DropdownArrowIcon } from '../../../../images/icons/DropdownArrow/DropdownArrow'

/**
 *  Table headgin - Filter trigger
 *
 *  @param {string} title [Heading title]
 *  @param {string} param [the filterable param, this will be sent to API]
 *  @param {object} state [Table component state, passed to be replicated here and used as reference]
 *  @param {function} filterTrigger [onClick action function. Need: 'sortedBy' and 'sortedType' params]
 */
export default class TableHeading extends React.Component<any, any> {

    /**
     * Initialize this component state
     * with a replica of parent state passed as props
     */
    constructor(props: any) {
        super(props)
        this.state = this.props.state
    }

    /**
     * When parent component update the State
     * it should update this component state
     */
    componentWillReceiveProps(nextProps: any) {
        this.setState(nextProps.state)
    }

    /**
     * onClick action, check if the actual state param is the same
     * as the one on the click
     * If the click have been on the active filter param,
     * it return the oposite order
     * If NOT, it return as it is the default order
     *
     * @param  {string} sortedBy
     * @return {string} [sortBy order]
     */
    toggleOrder(sortedBy: string) {

        if (sortedBy === this.state.sortedBy) {
            return (this.state.sortedType === 'asc') ? 'desc' : 'asc'
        }

        return 'asc'
    }

    /**
     * Check if this component param is on the active state.
     * If yes return active to be applied as component class
     *
     * @param  {string} sortedBy [This component param]
     */
    toggleActive(sortedBy: string) {

        if (sortedBy === this.state.sortedBy) {
            return 'active'
        }

        return ''
    }

    render() {

        const {
            param,
            title,
        } = this.props

        return(
            <div
                className={`table__title column ${(this.props.noMargin) ?
                    'no-margin' : ''
                } ${this.toggleActive(param)} ${this.state.sortedType}`}
                onClick={() => this.props.filterTrigger({
                    sortedBy: param,
                    sortedType: this.toggleOrder(param),
                })}
            >
                {title} <DropdownArrowIcon />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Table/TableHeading/TableHeading.tsx